import { useState, useEffect } from 'react';



export const focusRef = (inputRef) => {
    if (inputRef?.current) {
        inputRef.current.focus();
    }
};

export const blurRef = (inputRef) => {
    if (inputRef?.current) {
        inputRef.current.blur();
    }
};

export const useDebounce = (value, delay) => {
    const [debouncedValues, setDebouncedValues] = useState(value);

    useEffect(() => {
        const handler = setTimeout(
            () => {
                setDebouncedValues(value);
            },
            value ? delay : 0
        );

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return debouncedValues;
};

export const addItem = (items, setItems, item) => {
    const newItems = items && items.length ? [...items].concat(item) : [item];
    setItems(newItems);
};

export const deleteItem = (items, setItems, item) => {
    const newItems = [...items].filter((i) => (item.id ? i.id !== item.id : i.name !== item.name));
    setItems(newItems);
};



//export const deleteItemExl = (items, setItems, item) => {
//    const newItems = [...items].filter((i) => (item.id ? i.id !== item.id : i.name !== item.name));
//    setItems(newItems);
//    return newItems;
//};

export const addItemExl = (items, setItems, item) => {
    const newItems = items && items.length ? [...items].concat(item) : [item];
    setItems(newItems);
};

export const deleteItemExl = (items, setItems, item) => {

    const newItems = [...items].filter((i) => (item.id ? i.id !== item.id : i.name !== item.name));
    setItems(newItems);
};

export const getSuggestionsLocally = (options, userInput) => {
    if (!userInput || !userInput.length) {
        return options;
    }

    const reduce = (s) => s.replace(/\s+/g, '').toLowerCase();

    const isMatched = (o) => reduce(o.name).includes(reduce(userInput));

    return options.filter((o) => isMatched(o));
};

export const matchOptions = (options, userInput) => {
    if (!userInput || !userInput.length) {
        return options;
    }
    return getSuggestionsLocally(options, userInput);
};

export const scrollToElement = (id) => {
    const divToScrollTo = document.getElementById(id);
    if (divToScrollTo) {
        divToScrollTo.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
};

export const scrollToHistoryAnchor = (anchor, dispatch) => {
    const anchorEl = document.getElementById(anchor);
    if (anchorEl) {
        anchorEl.scrollIntoView();
        dispatch({
            type: 'SET_ANCHOR_TAG',
            payload: null,
        });
    }
}
